/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Games_UnassignedInputs */

const th_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมที่รอกำหนดสถานที่`)
};

const en_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games awaiting a venue`)
};

const ja_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会場未定の試合`)
};

const zh_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未安排场馆的比赛`)
};

const es_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partidos pendientes de pabellón`)
};

const pt_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos aguardando ginásio`)
};

const id_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertandingan tanpa tempat`)
};

const fr_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matchs sans salle`)
};

const tl_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga larong walang venue`)
};

const vi_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trận chưa có địa điểm`)
};

const ko_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기장 미배정 경기`)
};

const de_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spiele ohne Halle`)
};

const ru_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчи без площадки`)
};

const tr_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salonu olmayan maçlar`)
};

const it_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partite senza impianto`)
};

const pl_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mecze bez hali`)
};

const uk_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Матчі без майданчика`)
};

const hi_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिना स्थल वाले मैच`)
};

const ar_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مباريات بلا صالة`)
};

const ms_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perlawanan tanpa tempat`)
};

const bn_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাঠবিহীন খেলা`)
};

const zh_tw2_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未安排場館的比賽`)
};

const zh_hk2_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未安排場館的比賽`)
};

const ur_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بغیر مقام کے میچ`)
};

const fa_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازی‌های بدون سالن`)
};

const sw_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Michezo isiyo na ukumbi`)
};

const nl_games_unassigned = /** @type {(inputs: Games_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wedstrijden zonder zaal`)
};

/**
* | output |
* | --- |
* | "Games awaiting a venue" |
*
* @param {Games_UnassignedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const games_unassigned = /** @type {((inputs?: Games_UnassignedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Games_UnassignedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_games_unassigned(inputs)
	if (locale === "ja") return ja_games_unassigned(inputs)
	if (locale === "zh") return zh_games_unassigned(inputs)
	if (locale === "es") return es_games_unassigned(inputs)
	if (locale === "pt") return pt_games_unassigned(inputs)
	if (locale === "id") return id_games_unassigned(inputs)
	if (locale === "fr") return fr_games_unassigned(inputs)
	if (locale === "tl") return tl_games_unassigned(inputs)
	if (locale === "vi") return vi_games_unassigned(inputs)
	if (locale === "ko") return ko_games_unassigned(inputs)
	if (locale === "de") return de_games_unassigned(inputs)
	if (locale === "ru") return ru_games_unassigned(inputs)
	if (locale === "tr") return tr_games_unassigned(inputs)
	if (locale === "it") return it_games_unassigned(inputs)
	if (locale === "pl") return pl_games_unassigned(inputs)
	if (locale === "uk") return uk_games_unassigned(inputs)
	if (locale === "hi") return hi_games_unassigned(inputs)
	if (locale === "ar") return ar_games_unassigned(inputs)
	if (locale === "ms") return ms_games_unassigned(inputs)
	if (locale === "bn") return bn_games_unassigned(inputs)
	if (locale === "zh-TW") return zh_tw2_games_unassigned(inputs)
	if (locale === "zh-HK") return zh_hk2_games_unassigned(inputs)
	if (locale === "ur") return ur_games_unassigned(inputs)
	if (locale === "fa") return fa_games_unassigned(inputs)
	if (locale === "sw") return sw_games_unassigned(inputs)
	if (locale === "nl") return nl_games_unassigned(inputs)
	return en_games_unassigned(inputs)
});